import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';

import * as _ from 'lodash';

import './expertise.scss';
import { Col, Row } from 'reactstrap';

interface ExpertiseComponentProps {
  description: string;
  fields: any[];
}

class ExpertiseComponent extends Component<ExpertiseComponentProps, any> {

  render() {
    return (
        <article role="expertise" id="expertise">
          <Row>
            <Col md={6}>
              <h2>Expertise</h2>
              <figure className="profile text-center">
                <img src="/images/profile.jpg" alt=""/>
              </figure>
              <p className="text-center">{this.props.description}</p>
            </Col>
            <Col md={6}>
              <Row>
                {this.props.fields.map(this.renderExpertiseField)}
              </Row>
            </Col>
          </Row>
        </article>
    );
  }

  renderExpertiseField(field: any, index: number) {
    return (
        <Col xs={6} key={`exp-${index}`} role="expertise-field">
          <i className={`fa fa-${field.icon}`}/>
          <h4>{field.title}</h4>
          <p>{field.description}</p>
        </Col>
    );
  }
}

const mapStateToProps = (state: any): ExpertiseComponentProps => {
  return {
    description: _.get(state.cv, 'expertise.description'),
    fields: _.get(state.cv, 'expertise.fields', [])
  };
};

export default connect(mapStateToProps, null)(ExpertiseComponent);



// WEBPACK FOOTER //
// ./src/components/expertise/expertise.component.tsx